exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".swiper-pagination-bullet-active[data-v-5e31731d]{opacity:1;background:#dbfe54!important}", ""]);

// exports
